module.exports = __webpack_public_path__ + "img/outline.7aae4018.svg";